<template>
  <span v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card data-testid="cars-page">
      <v-toolbar :height="toolbar_height" text :color="$vuetify.theme.dark ? '' : 'white'" class="mb-4 start-tour-cars-1">
        <!-- Desktop версия -->
        <template v-if="!isMobile">
          <tag-filter v-model="selectedTagIds" class="mr-2" />
          <v-btn :to="`/search_free`" small text>{{ $t("custom.search_free") }}</v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line clearable
            hide-details data-testid="cars-search"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn class="mr-2" small color="success" to="/cars/new">{{
            $t("custom.add_car")
            }}</v-btn>
          <v-btn small color="secondary" to="/archive_cars">{{
            $t("custom.archive")
            }}</v-btn>
          <v-btn v-if="
            cars &&
            cars.length > 0 &&
            (isAdminPlus)
          " icon @click="toXlsx()" class="ml-2">
            <v-icon style="cursor: pointer" color="success">
              mdi-file-excel-outline
            </v-icon>
          </v-btn>
          <v-btn v-if="company && company.taxi_park_type && company.taxi_park_type != 'not_taxi'" icon
            @click="syncTaxiVehicles" :loading="isLoadingSyncTaxiVehicles">
            <v-icon>mdi-sync</v-icon>
          </v-btn>
          <v-btn icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
            }/${$root.$i18n.locale}/categories/7`" target="_blank">
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
        </template>

        <!-- Mobile версия -->
        <v-container v-else fluid class="pa-2">
          <v-row dense align="center">
            <v-col cols="auto">
              <tag-filter v-model="selectedTagIds" small />
            </v-col>
            <v-col>
              <v-btn :to="`/search_free`" small block outlined>{{ $t("custom.search_free") }}</v-btn>
            </v-col>
          </v-row>
          <v-row dense class="mt-2">
            <v-col cols="12">
              <v-text-field 
                v-model="search" 
                append-icon="mdi-magnify" 
                :label="$t('custom.search')" 
                single-line 
                clearable
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="mt-2">
            <v-col cols="6">
              <v-btn small color="success" to="/cars/new" block>{{
                $t("custom.add_car")
              }}</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn small color="secondary" to="/archive_cars" block>{{
                $t("custom.archive")
              }}</v-btn>
            </v-col>
          </v-row>
          <v-row dense class="mt-2" align="center" justify="center">
            <v-col cols="auto">
              <v-btn v-if="
                cars &&
                cars.length > 0 &&
                (isAdminPlus)
              " icon @click="toXlsx()">
                <v-icon style="cursor: pointer" color="success">
                  mdi-file-excel-outline
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="auto" v-if="company && company.taxi_park_type && company.taxi_park_type != 'not_taxi'">
              <v-btn icon @click="syncTaxiVehicles" :loading="isLoadingSyncTaxiVehicles">
                <v-icon>mdi-sync</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
                }/${$root.$i18n.locale}/categories/7`" target="_blank">
                <v-icon>mdi-help-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-toolbar>
      <v-data-table v-model="selected" :headers="headers" :loading="isLoading"
        :loading-text="$t('custom.loading_table')" :items="cars" :search="search" :custom-filter="customFilterCars" sort-by="sort" :sort-desc="false"
        item-key="id" mobile-breakpoint="100" :class="!isMobile ? '' : 'is-mobile'" dense :items-per-page="50"
        :footer-props="tableFooterProps([20, 50, 100, -1])" id="registration-step-37">
        <template slot="header" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text" :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]" @click="changeSort(header.value)">
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="item" slot-scope="props">
          <tr @dblclick="replaceToCar(props.item)" :class="props.item.active ? '' : 'grey--text text--lighten-1'">
            <td class="text-center" :key="props.item.id">
              <router-link id="car_id" :to="{ path: `/cars/${props.item.id}` }">
                <v-chip 
                  small 
                  :color="getStateColor(props.item.state)" 
                  dark
                  style="min-width: 60px; justify-content: center;">
                  {{ props.item.id }}
                </v-chip>
              </router-link>
            </td>
            <td class="text-center">
              <div class="d-flex flex-column align-center justify-center" style="max-width: 150px;">
                <v-avatar size="50" class="my-2">
                  <v-img
                    :src="props.item.photo || getDefaultImage()"
                    :lazy-src="getDefaultImage()"
                    :alt="props.item.car_name"
                    @error="handleImageError($event, props.item)"
                    @click="replaceToCar(props.item)"
                    style="cursor: pointer;"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-2"
                          size="20"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <!-- FT-167: иконка ВНУТРИ существующей ячейки. Новых <td> не
                     добавляем — строки здесь рисуются ручными ячейками, связанными
                     с headers только порядком, и лишняя сдвинула бы полтаблицы.
                     Тултип — Vuetify-компонент в той же форме, что у цен ниже по
                     файлу: строчный признак ведёт себя одинаково на всех трёх
                     экранах фичи (решение USER). -->
                <v-tooltip v-if="showPriceGap(props.item)" bottom color="grey darken-3"
                  open-on-click :open-on-hover="!isMobile">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" data-testid="price-gap-icon" small
                      color="warning" style="cursor: help;">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div style="text-align: left; padding: 4px;" class="white--text">
                    <div v-for="line in priceGapLines(props.item)" :key="line">{{ line }}</div>
                  </div>
                </v-tooltip>
                <router-link 
                  :to="{ path: `/cars/${props.item.id}` }"
                  class="text-center"
                  style="text-decoration: none; font-weight: 500; font-size: 13px; line-height: 1.3; word-break: break-word;">
                  {{ props.item.car_name }}
                </router-link>
              </div>
            </td>
            <td class="text-center">
              <router-link :to="{ path: `/cars/${props.item.id}` }">
                <v-chip 
                  small 
                  color="primary"
                  dark
                  style="min-width: 60px; justify-content: center; cursor: pointer;">
                  {{ props.item.code }}
                </v-chip>
              </router-link>
            </td>
            <!-- Состояние -->
            <td class="text-center align-center">
              <v-menu offset-y v-if="props.item.state == 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('states.normal'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="success">
                    mdi-thumb-up
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index"
                    @click="updateCarState(props.item.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.state == 2">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('states.in_service'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="secondary">
                    mdi-tools
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index"
                    @click="updateCarState(props.item.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.state == 3">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('states.critical'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="error">
                    mdi-alert-box
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index"
                    @click="updateCarState(props.item.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.state == 4">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('states.long_rent'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="pink">
                    mdi-all-inclusive
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index"
                    @click="updateCarState(props.item.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.state == 5">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('states.no_rent'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="info">
                    mdi-airplane-off
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index"
                    @click="updateCarState(props.item.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.state == 6">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('states.service_needed'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="orange">
                    mdi-alarm-light
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index"
                    @click="updateCarState(props.item.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
            <td class="text-center text-no-wrap" :style="user_role == 'guest' || user_role == 'partner'
              ? 'display: none;'
              : ''
              ">
              {{ props.item.number }}
            </td>
            <td class="text-center">{{ props.item.color }}</td>
            <td class="text-center">{{ props.item.year }}</td>
            <td class="text-center" v-for="(period, index) in periods" :key="period.index">
              <v-tooltip bottom color="grey darken-3" open-on-click :open-on-hover="!isMobile">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" style="cursor: help;">
                    {{ returnPrice(props.item.id, index) }}
                  </span>
                </template>
                <div style="text-align: left; padding: 4px;" class="white--text">
                  <div v-if="getDefaultPriceForPeriod(props.item.id, index) !== null" class="mb-1">
                    <strong>{{ $t('cars.base_price') }}:</strong> {{ getDefaultPriceForPeriod(props.item.id, index) }}
                  </div>
                  <div v-for="sp in getSeasonalPricesForPeriod(props.item.id, index)" :key="sp.season_id" class="mb-1">
                    <span class="light-blue--text text--lighten-2">{{ sp.dateRange }}:</span> {{ sp.price }}
                  </div>
                </div>
              </v-tooltip>
            </td>
            <td class="text-center">
              <v-tooltip bottom color="grey darken-3" open-on-click :open-on-hover="!isMobile">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" style="cursor: help;">
                    {{ returnPrice(props.item.id, periods.length) }}
                  </span>
                </template>
                <div style="text-align: left; padding: 4px;" class="white--text">
                  <div v-if="getDefaultPriceForPeriod(props.item.id, periods.length) !== null" class="mb-1">
                    <strong>{{ $t('cars.base_price') }}:</strong> {{ getDefaultPriceForPeriod(props.item.id, periods.length) }}
                  </div>
                  <div v-for="sp in getSeasonalPricesForPeriod(props.item.id, periods.length)" :key="sp.season_id" class="mb-1">
                    <span class="light-blue--text text--lighten-2">{{ sp.dateRange }}:</span> {{ sp.price }}
                  </div>
                </div>
              </v-tooltip>
            </td>
            <td class="text-center">{{ props.item.price_hour }}</td>
            <td class="text-center">{{ props.item.deposit }}</td>
            <td class="text-center" nowrap>
              {{ returnDate(props.item.last_inspection) }}
            </td>
            <!-- tires types -->
            <td class="text-center">
              <v-menu offset-y v-if="props.item.tire_type == 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('wheels.summer'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="yellow">
                    mdi-weather-sunny
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(tire_type, index) in tire_types" :key="index"
                    @click="updateTireType(props.item.id, tire_type.id)">
                    <v-list-item-title>
                      {{ tire_type.tire_type }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.tire_type == 2">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('wheels.winter'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="info">
                    mdi-snowflake
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(tire_type, index) in tire_types" :key="index"
                    @click="updateTireType(props.item.id, tire_type.id)">
                    <v-list-item-title>
                      {{ tire_type.tire_type }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.tire_type == 3">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('wheels.all_seasons'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="info">
                    mdi-theme-light-dark
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(tire_type, index) in tire_types" :key="index"
                    @click="updateTireType(props.item.id, tire_type.id)">
                    <v-list-item-title>
                      {{ tire_type.tire_type }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.tire_type == 4">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('wheels.both'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="info">
                    mdi-circle-half-full
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(tire_type, index) in tire_types" :key="index"
                    @click="updateTireType(props.item.id, tire_type.id)">
                    <v-list-item-title>
                      {{ tire_type.tire_type }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="props.item.tire_type == 5">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-tooltip="{
                    content: $t('wheels.spike'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="light-green">
                    mdi-pine-tree
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(tire_type, index) in tire_types" :key="index"
                    @click="updateTireType(props.item.id, tire_type.id)">
                    <v-list-item-title>
                      {{ tire_type.tire_type }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          {{ $t("custom.no_data_in_table") }}
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
          {{ $t("tables.no_search_result", { msg: search }) }}
        </v-alert>
      </v-data-table>
    </v-card>
  </span>
</template>
<script>
import moment from "moment";
import { hasPriceGaps, priceGapsLines } from "@/utils/priceGaps";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
import PullToRefresh from "pulltorefreshjs";
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { saveAs } from "file-saver";
import xlsx from "json-as-xlsx";
import TagFilter from "@/components/shared/TagFilter.vue";
export default {
  components: { TagFilter },
  data() {
    return {
      cars: [],
      all_cars: [],
      prices: [],
      editedCar: "",
      bookings: [],
      filtred_bookings_car_ids: [],
      states: [
        { id: 1, state: this.$t("states.normal") },
        { id: 2, state: this.$t("states.in_service") },
        { id: 3, state: this.$t("states.critical") },
        { id: 4, state: this.$t("states.long_rent") },
        { id: 5, state: this.$t("states.no_rent") },
        { id: 6, state: this.$t("states.service_needed") },
      ],
      tire_types: [
        { id: 1, tire_type: this.$i18n.t("wheels.summer") },
        { id: 2, tire_type: this.$i18n.t("wheels.winter") },
        { id: 3, tire_type: this.$i18n.t("wheels.all_seasons") },
        { id: 4, tire_type: this.$i18n.t("wheels.both") },
        { id: 5, tire_type: this.$i18n.t("wheels.spike") },
      ],
      error: "",
      snack_text: "",
      snack_mode: "",
      snack_color: "",
      search: "",
      sort_date_range_not_formatted: {
        start: new Date(),
        end: null,
      },
      sort_date_range: null,
      showRangeMenu: false,
      attrs_calendar: [
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "outline",
            contentClass: "italic",
          },
          dates: new Date(),
        },
      ],
      car_class: ["Эконом", "Средний", "Бизнес", "Коммерческий"],
      selectedClasses: null,
      selectedTagIds: [],
      dialog: false,
      options: {
        sortBy: "car_name",
      },
      selected: [],
      seasons: [],
      selected_season: null,
      periods: [],
      headers: [
        { text: this.$t("custom.id"), value: "id", align: "center" },
        { text: this.$t("cars.name"), value: "car_name", align: "center" },
        { text: this.$t("custom.code"), value: "code", align: "center" },
        { text: this.$t("custom.state"), value: "state", align: "center" },
        {
          text: this.$t("common.license_plate"),
          sortable: false,
          value: "number",
          align: "center",
        },
        { text: this.$t("custom.color"), sortable: false, align: "center" },
        { text: this.$t("custom.year"), sortable: false, align: "center" },
        // { text: "+31", sortable: false, align: "center" },
        {
          text: this.$t("custom.price_for_hour"),
          sortable: false,
          align: "center",
        },
        { text: this.$t("bookings.deposit"), sortable: false, align: "center" },
        {
          text: this.$t("to.to_short"),
          value: "last_inspection",
          align: "center",
        },
        { text: this.$t("wheels.tire"), sortable: false, align: "center" },
      ],
      isMobile: false,
      isLoading: false,
      isLoadingSyncTaxiVehicles: false,
    };
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      if (
        this.company &&
        this.company.periods
      ) {
        this.isLoading = true;
        // this.periods.push(`${this.periods[this.periods.length][1]}+`);
        this.axios
          .get("/api/v1/all_cars_with_bookings", {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            // Делаю заголовки из периодов
            this.company.periods
              .sort((a, b) => {
                return parseInt(b) - parseInt(a);
              })
              .forEach((period) => {
                this.periods.push(period);
                this.headers.splice(7, 0, {
                  text: `${period}`,
                  sortable: false,
                  align: "center",
                });
              });
            let last_value = this.periods
              .sort((a, b) => {
                return parseInt(a) - parseInt(b);
              })[self.periods.length - 1].split(" - ")[1];
            if (last_value) {
              this.headers.splice(7 + self.periods.length, 0, {
                text: `${last_value}+`,
                sortable: false,
                align: "center",
              });
            } else {
              this.periods.push({
                text: `+`,
                sortable: false,
                align: "center",
              });
            }
            this.seasons = response.data.seasons;
            this.seasons.forEach((season) => {
              let start = moment(season.start_date, "DD.MM");
              let end = moment(season.end_date, "DD.MM");
              // сезон через новый год (например 01.11–01.03): end < start → wrap-around
              if (end.isBefore(start) ? (moment().isSameOrAfter(start) || moment().isSameOrBefore(end)) : moment().isBetween(start, end, null, "[]")) {
                this.selected_season = season;
              }
            });
            response.data.cars.data.forEach((car) => {
              this.cars.push(car.attributes);
              this.all_cars.push(car.attributes);
            });
            response.data.cars.included.forEach((price) => {
              this.prices.push(price.attributes);
            });
            this.bookings = [];
            // берем из сериалазера, но он пустой, поэтому не используем
            // response.data.bookings.data.forEach((booking) => {
            //   if (booking.attributes.active) {
            //     this.bookings.push(booking.attributes);
            //   }
            // });
          })
          .catch((error) => {
            this.isLoading = false;
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.input_periods"), this.$t("errors.input_periods_text"), "warning");
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  mounted: function () {
    if (
      this.$tours["registrationTour"] &&
      this.$store.getters.getTourNextStep
    ) {
      this.$tours["registrationTour"].nextStep();
    }
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  watch: {
    sort_date_range_not_formatted() {
      if (
        this.sort_date_range_not_formatted.start &&
        this.sort_date_range_not_formatted.end
      ) {
        this.sort_date_range = `${moment(
          this.sort_date_range_not_formatted.start
        ).format("DD-MM-YYYY H:mm")} - ${moment(
          this.sort_date_range_not_formatted.end
        ).format("DD-MM-YYYY H:mm")}`;
      }
    },
    sort_date_range: function () {
      var self = this;
      this.filtred_bookings_car_ids = [];
      this.cars = [];
      this.all_cars.forEach((car) => this.cars.push(car));

      // Зазаор между бронями
      let zazor =
        self.$store.getters.getCompany.interval_bookings > 0
          ? self.$store.getters.getCompany.interval_bookings
          : 1;

      // Удаление из массива объектов по значению ключа.
      // Объявление ЗДЕСЬ, а не внутри ветки: раньше оно стояло дважды — по копии
      // в ветке диапазона и в ветке одной даты. `var` поднимается на всю функцию,
      // поэтому no-redeclare честно ругался на «два объявления в одной области»,
      // но области видимости тут одна, а ПУТИ ИСПОЛНЕНИЯ разные: ветки взаимно
      // исключают друг друга, и присваивание происходило только в той, что
      // выполнилась. Снести одну копию как «дубль» нельзя — вторая ветка тогда
      // зовёт undefined.
      const removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
          if (
            arr[i] &&
            Object.prototype.hasOwnProperty.call(arr[i], attr) &&
            arguments.length > 2 &&
            arr[i][attr] === value
          ) {
            arr.splice(i, 1);
          }
        }
        return arr;
      };
      if (this.sort_date_range && this.sort_date_range.includes(" - ")) {
        let check_dates = this.sort_date_range.split(" - ");
        // выбераем сезон цен
        self.selected_season = null;
        self.seasons.forEach((season) => {
          let start = moment(season.start_date, "DD.MM");
          let end = moment(season.end_date, "DD.MM");
          if (moment(check_dates, "DD-MM-YYYY H:mm").isBetween(start, end)) {
            self.selected_season = season;
          }
        });

        function checkDates(booking_dates) {
          let start_booking = moment(
            booking_dates[0],
            "DD-MM-YYYY H:mm"
          ).subtract(zazor, "hours");
          let end_booking = moment(booking_dates[1], "DD-MM-YYYY H:mm").add(
            zazor,
            "hours"
          );
          let start_check_period = moment(check_dates[0], "DD-MM-YYYY H:mm");
          let end_check_period = moment(check_dates[1], "DD-MM-YYYY H:mm");

          if (
            moment(start_booking).isBetween(
              start_check_period,
              end_check_period,
              "hour"
            ) ||
            moment(end_booking).isBetween(
              start_check_period,
              end_check_period,
              "hour"
            ) ||
            moment(start_check_period).isBetween(
              start_booking,
              end_booking,
              "hour"
            ) ||
            moment(end_check_period).isBetween(
              start_booking,
              end_booking,
              "hour"
            )
          ) {
            return true;
          } else {
            return false;
          }
        }
        this.bookings.forEach((booking) => {
          let booking_dates = [];
          booking_dates.push(booking.start_date);
          booking_dates.push(booking.end_date);

          if (checkDates(booking_dates)) {
            this.filtred_bookings_car_ids.push(booking.car_id);
          }

          let non_active_cars = this.cars.forEach((car) => {
            if (!car.active) {
              this.filtred_bookings_car_ids.push(car.id);
            }
          });
        });
        this.filtred_bookings_car_ids.forEach((id) =>
          removeByAttr(this.cars, "id", id)
        );
      } else if (
        this.sort_date_range &&
        !this.sort_date_range.includes(" - ") &&
        this.sort_date_range.length > 0
      ) {
        let check_date = this.sort_date_range;
        // выбераем сезон цен
        self.selected_season = null;
        self.seasons.forEach((season) => {
          let start = moment(season.start_date, "DD.MM");
          let end = moment(season.end_date, "DD.MM");
          if (moment(check_date, "DD-MM-YYYY H:mm").isBetween(start, end)) {
            self.selected_season = season;
          }
        });

        function checkDates(booking_dates) {
          let start_booking = moment(
            booking_dates[0],
            "DD-MM-YYYY H:mm"
          ).subtract(zazor, "hours");
          let end_booking = moment(booking_dates[1], "DD-MM-YYYY H:mm").add(
            zazor,
            "hours"
          );
          let start_check_date = moment(check_date, "DD-MM-YYYY H:mm");

          if (
            moment(start_check_date).isBetween(
              start_booking,
              end_booking,
              "hour"
            )
          ) {
            return true;
          } else {
            return false;
          }
        }
        this.bookings.forEach((booking) => {
          let booking_dates = [];
          booking_dates.push(booking.start_date);
          booking_dates.push(booking.end_date);

          if (checkDates(booking_dates)) {
            this.filtred_bookings_car_ids.push(booking.car_id);
          }

          let non_active_cars = this.cars.forEach((car) => {
            if (!car.active) {
              this.filtred_bookings_car_ids.push(car.id);
            }
          });
        });
        this.filtred_bookings_car_ids.forEach((id) =>
          removeByAttr(this.cars, "id", id)
        );
      } else {
        this.isLoading = true;
        // Костыль, запоминает ссылку на response.data из created и не переопределяет all_cars, нихера не помогает
        this.axios
          .get("/api/v1/cars", {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            let cars = [];
            response.data.data.forEach((element) => {
              cars.push(element.attributes);
            });
            this.cars = cars;
            // выбераем сезон цен
            self.selected_season = null;
            self.seasons.forEach((season) => {
              let start = moment(season.start_date, "DD.MM");
              let end = moment(season.end_date, "DD.MM");
              // сезон через новый год (например 01.11–01.03): end < start → wrap-around
              if (end.isBefore(start) ? (moment().isSameOrAfter(start) || moment().isSameOrBefore(end)) : moment().isBetween(start, end, null, "[]")) {
                self.selected_season = season;
              }
            });
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.cars_load"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      }
    },
    selectedClasses() { this.applyFilters(); },
    selectedTagIds() { this.applyFilters(); },
  },
  computed: {
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    toolbar_height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 260
        case 'sm': return 260
        case 'md': return 65
        case 'lg': return 65
        case 'xl': return 65
        default: return 65
      }
    },
  },
  methods: {
    applyFilters() {
      let result = this.all_cars.slice();
      // Фильтр по классу
      if (this.selectedClasses && this.selectedClasses.length > 0) {
        result = result.filter((car) => car.car_class === this.selectedClasses);
      }
      // Фильтр по тегам
      if (this.selectedTagIds && this.selectedTagIds.length > 0) {
        result = result.filter((car) =>
          car.tags && car.tags.some((t) => this.selectedTagIds.includes(t.id))
        );
      }
      // Убираем забронированные авто (фильтр по датам)
      if (this.filtred_bookings_car_ids.length > 0) {
        const busySet = new Set(this.filtred_bookings_car_ids);
        result = result.filter((car) => !busySet.has(car.id));
      }
      this.cars = result;
    },
    customFilterCars(value, search, item) {
      if (!search) return true;
      const searchLower = search.toLowerCase();
      return (
        String(item.id).includes(searchLower) ||
        item.car_name?.toLowerCase().includes(searchLower) ||
        item.code?.toLowerCase().includes(searchLower) ||
        item.number?.toLowerCase().includes(searchLower) ||
        item.vin?.toLowerCase().includes(searchLower) ||
        item.body_number?.toLowerCase().includes(searchLower) ||
        item.pts?.toLowerCase().includes(searchLower) ||
        item.registration_certificate?.toLowerCase().includes(searchLower) ||
        item.color?.toLowerCase().includes(searchLower) ||
        item.description?.toLowerCase().includes(searchLower) ||
        item.car_class?.toLowerCase().includes(searchLower) ||
        String(item.year).includes(searchLower)
      );
    },
    translateState(state) {
      const states = {
        1: this.$t('states.normal'),
        2: this.$t('states.in_service'),
        3: this.$t('states.critical'),
        4: this.$t('states.long_rent'),
        5: this.$t('states.no_rent'),
        6: this.$t('states.service_needed')
      };
      return states[state] || '';
    },
    translateTireType(tire_type) {
      const types = {
        1: this.$t('wheels.summer'),
        2: this.$t('wheels.winter'),
        3: this.$t('wheels.all_seasons'),
        4: this.$t('wheels.both'),
        5: this.$t('wheels.spike')
      };
      return types[tire_type] || '';
    },
    getPriceForExcel(car_id, season_id, periodIndex) {
      const carPrices = this.prices.filter(p => p.car_id == car_id && p.season_id == season_id);
      if (carPrices.length > 0 && carPrices[0].values && carPrices[0].values[periodIndex] !== undefined) {
        return carPrices[0].values[periodIndex];
      }
      return '';
    },
    toXlsx() {
      if (this.isStaff) {
        let self = this;
        
        const baseColumns = [
          { label: "ID", value: "id" },
          { label: this.$t("cars.name"), value: "car_name" },
          { label: this.$t("custom.code"), value: "code" },
          { label: this.$t("bookings.active"), value: (row) => {
            return row.active ? this.$t("custom.yes") : this.$t("custom.no");
          }},
          { label: this.$t("custom.state"), value: (row) => {
            return this.translateState(row.state);
          }},
          { label: this.$t("cars.gov_number"), value: "number" },
          { label: this.$t("cars.vin"), value: "vin" },
          { label: this.$t("cars.body_number"), value: "body_number" },
          { label: this.$t("cars.reg_number"), value: "pts" },
          { label: this.$t("cars.sts_number"), value: "registration_certificate" },
          { label: this.$t("custom.color"), value: "color" },
          { label: this.$t("custom.year"), value: "year" },
          { label: this.$t("cars.class"), value: "car_class" },
          { label: this.$t("custom.price_for_hour"), value: "price_hour" },
          { label: this.$t("bookings.deposit"), value: "deposit" },
          { label: this.$t("wheels.tire"), value: (row) => {
            return this.translateTireType(row.tire_type);
          }},
          { label: this.$t("custom.description"), value: "description" },
        ];
        
        const sortedPeriods = [...this.periods].sort((a, b) => parseInt(a) - parseInt(b));
        const lastPeriodValue = sortedPeriods.length > 0 ? sortedPeriods[sortedPeriods.length - 1].split(" - ")[1] : '';
        
        const mainPriceColumns = sortedPeriods.map((period, index) => ({
          label: period,
          value: (row) => this.getPriceForExcel(row.id, null, index)
        }));
        if (lastPeriodValue) {
          mainPriceColumns.push({
            label: `${lastPeriodValue}+`,
            value: (row) => this.getPriceForExcel(row.id, null, sortedPeriods.length)
          });
        }
        
        let data = [
          {
            sheet: this.$t("cars.base_price"),
            columns: [...baseColumns, ...mainPriceColumns],
            content: this.cars,
          },
        ];
        
        this.seasons.forEach(season => {
          const seasonPriceColumns = sortedPeriods.map((period, index) => ({
            label: period,
            value: (row) => this.getPriceForExcel(row.id, season.id, index)
          }));
          if (lastPeriodValue) {
            seasonPriceColumns.push({
              label: `${lastPeriodValue}+`,
              value: (row) => this.getPriceForExcel(row.id, season.id, sortedPeriods.length)
            });
          }
          
          data.push({
            sheet: `${season.start_date} - ${season.end_date}`,
            columns: [
              { label: "ID", value: "id" },
              { label: this.$t("cars.name"), value: "car_name" },
              { label: this.$t("custom.code"), value: "code" },
              ...seasonPriceColumns
            ],
            content: this.cars,
          });
        });
        
        let settings = {
          fileName: "cars",
          extraLength: 3,
          writeMode: "write",
          writeOptions: {
            bookType: "xlsx",
            type: "array",
          },
          RTL: false,
        };
        let wbout = xlsx(data, settings);
        var blob_data = new Blob([new Uint8Array(wbout)], { type: "application/octet-stream" });
        if (!Capacitor.isNativePlatform()) {
          saveAs(blob_data, 'cars.xlsx');
        } else {
          if (Filesystem.checkPermissions()) {
            const getBase64FromBlob = async (blob) => {
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;
                  resolve(base64data);
                }
              });
            }
            getBase64FromBlob(blob_data).then(
              (base64) => {
                async function writeFile() {
                  return await Filesystem.writeFile({
                    path: 'cars.xlsx',
                    data: base64,
                    directory: Directory.Documents,
                  });
                }
                let writedFile = writeFile().then((getUriResult) => {
                  let shareFile = async () => {
                    await Share.share({
                      title: 'Download document',
                      files: [getUriResult.uri],
                    }).catch((error) => {
                      console.log("shareFile", error)
                    });
                  };
                  let sharedFile = shareFile();
                }).catch((error) => {
                  console.log("shareFile", error)
                });
              }
            );
          } else {
            Filesystem.requestPermissions();
          }
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning", 3000);
      }
    },
    getStateColor(state) {
      const stateColors = {
        1: 'success',
        2: 'secondary',
        3: 'error',
        4: 'pink',
        5: 'info',
        6: 'orange'
      };
      return stateColors[state] || 'grey';
    },
    getDefaultImage() {
      // Проверяем тип объектов аренды
      const rentalObject = this.company?.rental_object || 'cars';
      
      if (rentalObject === 'cars') {
        // Для автомобилей - иконка авто
        return 'https://web.rentprog.com/img/no-car-image-min.png';
      } else {
        // Для остальных - нейтральная SVG заглушка
        return '/img/no-image-placeholder.svg';
      }
    },
    handleImageError(event, item) {
      // При ошибке загрузки заменяем на заглушку
      if (item.photo !== this.getDefaultImage()) {
        this.$set(item, 'photo', this.getDefaultImage());
      }
    },
    // FT-167. Гейт isStaff — второй пояс: основной серверный, внешним ролям
    // поле не приходит вовсе (REQ-05, FM-06).
    showPriceGap(item) {
      return this.isStaff && hasPriceGaps(item.price_gaps);
    },
    priceGapLines(item) {
      return priceGapsLines(item.price_gaps, this.$t.bind(this));
    },
    getDefaultPriceForPeriod(car_id, index) {
      const carPrices = this.prices.filter(price => price.car_id == car_id);
      const defaultPrice = carPrices.find(p => p.season_id == null);
      if (defaultPrice && defaultPrice.values && defaultPrice.values[index] !== undefined) {
        return defaultPrice.values[index];
      }
      return null;
    },
    getSeasonalPricesForPeriod(car_id, index) {
      const carPrices = this.prices.filter(price => price.car_id == car_id);
      const seasonalPrices = carPrices.filter(p => p.season_id != null);
      const result = [];
      seasonalPrices.forEach(sp => {
        const season = this.seasons.find(s => s.id == sp.season_id);
        if (season && sp.values && sp.values[index] !== undefined) {
          result.push({
            season_id: sp.season_id,
            dateRange: `${season.start_date} - ${season.end_date}`,
            price: sp.values[index]
          });
        }
      });
      return result;
    },
    returnPrice(car_id, index) {
      let self = this;
      let prices = null;
      let default_prices = null;
      if ((self.prices, car_id, index >= 0)) {
        prices = this.prices.filter((price) => {
          return price.car_id == car_id;
        });
        if (prices && prices.length > 0 && index >= 0) {
          default_prices = this.prices.filter((price) => {
            return price.season_id == null;
          });

          if (
            prices &&
            this.selected_season &&
            prices.filter((price) => price.season_id == this.selected_season.id)
              .length > 0
          ) {
            return prices.filter(
              (price) => price.season_id == this.selected_season.id
            )[0].values[index];
          } else {
            if (prices.filter((price) => price.season_id == null)[0]) {
              return prices.filter((price) => price.season_id == null)[0]
                .values[index];
            } else {
              return "?";
            }
          }
        } else {
          return "-";
        }
      } else {
        return "-";
      }
    },
    replaceToCar(car) {
      this.$router.push({ path: `/cars/${car.id}` });
    },
    updateCarState(id, state) {
      if (this.isStaff) {
        let car = this.cars.find((car) => car.id == id);
        if (car) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/cars/${id}`,
              {
                cars: {
                  state: state,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.cars.find((car) => car.id == id).state = state;
              this.$notify(this.$t("other.state_updated"), "", "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.change_car_state"));
              console.log(error);
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateTireType(id, tire_type) {
      if (this.isStaff) {
        let car = this.cars.find((car) => car.id == id);
        if (car) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/cars/${id}`,
              {
                cars: {
                  tire_type: tire_type,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.cars.find((car) => car.id == id).tire_type = tire_type;
              this.$notify(this.$t("other.tire_updated"), "", "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.change_car_tire_type"));
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    syncTaxiVehicles() {
      this.isLoadingSyncTaxiVehicles = true;
      this.axios.post('/api/v1/taxi/sync',
        {
          company_id: this.$store.getters.getCompany.company.id,
          sync_type: 'vehicles'
        },
        {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        }
      ).then((response) => {
        console.log(response);
      }).catch((error) => {
        this.setError(error, this.$t("errors.error"));
      }).finally(() => (this.isLoadingSyncTaxiVehicles = false));
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    returnDate(item) {
      if (item) {
        return moment(item, "YYYY-MM-DD").format("ll");
      } else {
        return "-";
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
};
</script>
